/**
 *
 *
 */

import { useEffect, useState } from 'react';
import {
  Content,
  Title,
  InputFormTable,
  Editor,
  ModalLayout,
  Row,
  Col,
  Text,
} from 'components';
import {
  Select,
  Input,
  Radio,
  InputNumber,
  Divider,
  Button,
  Card,
  Checkbox,
  Form,
  Empty,
} from 'antd';
import { FormOutlined, DeleteOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import MessageAlert from '../../../../../utils';

const initialData = {
  contract_date: {},
  data: {
    option_key: null, // 1,
    option_name: '', // '60개월(의무기간36개월)',
    option_value: 36, // 60, // 계약기간 (단위: null,// 월)
    option_value2: null, // 60, // 계약기간 (단위: null,// 월)
    option_price: 0, // 0,
    option_type: 'ADD_TOTAL', // ['ADD_TOTAL', 'MINUS_TOTAL', 'ADD_MONTH', 'MINUS_MONTH'],
    default: false, // true,
  },
};

let lastId = 0;

/**----------------------------------------
 * [Component] 총관리자: 상품등록 > 렌탈정보
 * ----------------------------------------
 */
const SalesInformation_rentalInformation = ({ defaultData, onChange }) => {
  /* ===== INITIAL ===== */

  /* ===== STATE ===== */
  // 모달
  const [modal, setModal] = useState(null);
  const [data, setData] = useState(initialData.data);

  // 사용기간
  const [contract_date, set_contract_date] = useState(
    defaultData?.contract_date ?? []
  );
  const [contract_date_key, set_contract_date_key] = useState(null);
  // 의무사용기간
  const [mandatory_usage_date_key, set_mandatory_usage_date_key] =
    useState(null);
  // 선 납입금
  const [advance_price, set_advance_price] = useState(
    defaultData?.advance_price ?? []
  );
  const [advance_price_key, set_advance_price_key] = useState(null);
  // 관리유형
  const [management, set_management] = useState(defaultData?.management ?? []);
  const [management_key, set_management_key] = useState(null);
  // 관리유형
  const [additional_cost, set_additional_cost] = useState(
    defaultData?.additional_cost ?? []
  );
  const [additional_cost_key, set_additional_cost_key] = useState(null);

  /* 설명 */
  const [advance_price_description, set_advance_price_description] =
    useState('-');
  const [contract_date_description, set_contract_date_description] =
    useState('-');
  const [
    mandatory_usage_date_description,
    set_mandatory_usage_date_description,
  ] = useState('-');
  const [management_description, set_management_description] = useState('-');
  const [additional_cost_description, set_additional_cost_description] =
    useState('-');

  const setFunctions = {
    contract_date,
    contract_date_key,
    mandatory_usage_date_key,
    advance_price,
    advance_price_key,
    management,
    management_key,
    additional_cost,
    additional_cost_key,

    set_contract_date,
    set_contract_date_key,
    set_mandatory_usage_date_key,
    set_advance_price,
    set_advance_price_key,
    set_management,
    set_management_key,
    set_additional_cost,
    set_additional_cost_key,
  };

  /* ===== FUNCTION ===== */
  /**--------------------
   *
   * --------------------
   */
  const onChangeData = (name, value) => {
    setData((p) => ({
      ...p,
      [name]: value,
    }));
  };

  /**--------------------
   * 추가
   * --------------------
   */
  const handleAddOption = async () => {
    if (!data?.option_name) {
      MessageAlert.info('옵션명을 입력해주세요.');
      return;
    }
    let newData = {
      ...data,
      option_key: moment().unix(),
      // option_key: uuidv4(),
    };

    switch (modal) {
      //
      case 'contract_date':
        set_contract_date((p) => [
          ...p,
          {
            ...newData,
            mandatory_usage_date: [],
          },
        ]);
        break;
      //
      case 'mandatory_usage_date':
        const fid = contract_date.findIndex(
          (item) => item.option_key === contract_date_key
        );
        set_contract_date((p) => [
          ...p.slice(0, fid),
          {
            ...p[fid],
            mandatory_usage_date: [...p[fid].mandatory_usage_date, newData],
          },
          ...p.slice(fid + 1),
        ]);
        break;
      //
      case 'advance_price':
      case 'management':
      case 'additional_cost':
      default:
        setFunctions[`set_${modal}`]((p) => [
          ...p,
          { ...newData, option_value: 0 },
        ]);
        break;
    } // switch: end
    setData(initialData.data);
    setModal(null);
  };

  /**--------------------
   * 수정
   * --------------------
   */
  const handleUpdateOption = async () => {
    let fid, fid2;
    // console.log('asdfsdfaasdf231123', data);
    if (!data?.option_name) {
      MessageAlert.info('옵션명을 입력해주세요.');
      return;
    }
    switch (modal) {
      //
      case 'mandatory_usage_date':
        // 상위 아이디 찾기
        for (let i in contract_date) {
          // 하위 아이디 찾기
          for (let j in contract_date[i].mandatory_usage_date) {
            if (
              contract_date[i].mandatory_usage_date[j].option_key ===
              data.option_key
            ) {
              fid = i;
              fid2 = j;
            }
          }
        }

        set_contract_date((p) => [
          ...p.slice(0, fid),
          {
            ...p[fid],
            mandatory_usage_date: [
              ...p[fid].mandatory_usage_date.slice(0, fid2),
              data,
              ...p[fid].mandatory_usage_date.slice(fid2 + 1),
            ],
          },
          ...p.slice(fid + 1),
        ]);
        break;

      //
      case 'contract_date':
      case 'advance_price':
      case 'management':
      case 'additional_cost':
      default:
        fid = setFunctions[modal].findIndex(
          (i) => i.option_key === data.option_key
        );
        setFunctions[`set_${modal}`]((p) => [
          ...p.slice(0, fid),
          data,
          ...p.slice(fid + 1),
        ]);
        break;
    } // switch: end

    setData(initialData.data);
    setModal(null);
  };

  /**--------------------
   * 항목 삭제
   * --------------------
   */
  const handleDeleteOption = async (type, option_key) => {
    if (!window.confirm('삭제 하시겠습니까?')) {
      return;
    }
    // 필터 익명함수
    const cb = (item) => item.option_key !== option_key;
    // 분기처리
    switch (type) {
      //
      case 'mandatory_usage_date':
        // 상위 아이디 찾기
        const fid = contract_date.findIndex(
          (item) =>
            item.mandatory_usage_date.findIndex(
              (item2) => item2.option_key === option_key
            ) >= 0
        );
        // 하위항목에서 제거
        set_contract_date((p) => [
          ...p.slice(0, fid),
          {
            ...p[fid],
            mandatory_usage_date: p[fid].mandatory_usage_date.filter(cb),
          },
          ...p.slice(fid + 1),
        ]);
        break;

      //
      case 'contract_date':
      case 'advance_price':
      case 'management':
      case 'additional_cost':
        const index = setFunctions[type].findIndex(
          (item) => item.option_key === option_key
        );

        setFunctions[`set_${type}`]((prev) => [
          ...prev.slice(0, index),
          ...prev.slice(index + 1),
        ]);
        setFunctions[`set_${type}_key`](null);
        // setFunctions[`set_${type}`](additional_cost.filter(cb));
        break;
    } // switch: end
  };

  /**--------------------
   * 타이틀
   * --------------------
   */
  const handleGetTitle = (v) => {
    switch (v) {
      case 'contract_date':
        return '계약기간';
      case 'mandatory_usage_date':
        return '의무사용기간';
      case 'advance_price':
        return '선 납입금';
      case 'management':
        return '관리유형';
      case 'additional_cost':
      default:
        return '추가비용';
    }
  };

  /**
   * 렌탈 정보 Default 변경
   * --
   * @param {*} k
   * @param {*} v
   * @param {*} arr
   * @param {*} callback
   */
  const handleDefaultValue = (k, v, arr, callback) => {
    const newArr = arr.map((item) =>
      item.option_key === k
        ? { ...item, default: v }
        : { ...item, default: false }
    );

    callback(newArr);
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    onChange({
      contract_date,
      advance_price,
      management,
      additional_cost,
      // advance_price_description,
      // contract_date_description,
      // mandatory_usage_date_description,
      // management_description,
      // additional_cost_description,
    });
  }, [contract_date, advance_price, management, additional_cost]);
  /* ===== VARIABLE ===== */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <Content style={{ width: '100%', maxWidth: '100%' }}>
        <Row>
          {/* ===== [사용기간] contract_date : start ===== */}
          <Col x={5} style={styles.columnWrapper}>
            <Title
              size={5}
              style={styles.title}
              subButton={
                <Button
                  size="small"
                  shape="round"
                  color="primary"
                  variant="outlined"
                  onClick={() => setModal('contract_date')}
                >
                  +추가
                </Button>
              }
            >
              계약기간
            </Title>
            <Divider style={styles.divider} />

            {/* === 데이터 리스트: start === */}
            <div>
              {contract_date.length > 0 ? (
                contract_date.map((item) => {
                  const isSelect = item.option_key === contract_date_key;

                  return (
                    <Card
                      key={`contract_date_${item.option_key}`}
                      size="small"
                      hoverable
                      className="boxShadow"
                      style={{
                        ...styles.card,
                        ...(isSelect && styles.cardSelect),
                      }}
                      styles={{
                        actions: {
                          padding: 0,
                          margin: 0,
                        },
                      }}
                      actions={[
                        <Button
                          size="small"
                          type="text"
                          onClick={(e) => {
                            e.preventDefault();
                            setData(item);
                            setModal('contract_date');
                          }}
                        >
                          <FormOutlined />
                        </Button>,
                        <Button
                          size="small"
                          type="text"
                          style={{ width: '49%' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteOption(
                              'contract_date',
                              item.option_key
                            );
                          }}
                        >
                          <DeleteOutlined />
                        </Button>,
                      ]}
                    >
                      <div
                        style={styles.cardInner}
                        onClick={() =>
                          set_contract_date_key(
                            isSelect ? null : item.option_key
                          )
                        }
                      >
                        <p>{item.option_name}</p>
                        <p
                          style={{
                            textAlign: 'right',
                            fontSize: '0.95em',
                            opacity: 0.75,
                            letterSpacing: -0.5,
                          }}
                        >
                          <Radio
                            style={{ marginRight: 2.5 }}
                            checked={item.default}
                            onChange={() =>
                              handleDefaultValue(
                                item.option_key,
                                !item.default,
                                contract_date,
                                set_contract_date
                              )
                            }
                          />
                          기본값
                        </p>
                      </div>
                    </Card>
                  );
                })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
            {/* === 데이터 리스트: end === */}
          </Col>
          {/* ===== [사용기간] contract_date : end ===== */}

          {/* ===== [의무사용기간] mandatory_usage_date : start ===== */}
          <Col x={5} style={styles.columnWrapper}>
            <Title
              size={5}
              style={styles.title}
              subButton={
                <Button
                  size="small"
                  shape="round"
                  color="primary"
                  variant="outlined"
                  onClick={() => setModal('mandatory_usage_date')}
                  disabled={contract_date_key === null}
                >
                  +추가
                </Button>
              }
            >
              의무 사용기간
            </Title>
            <Divider style={styles.divider} />
            {/* === 데이터 리스트: start === */}
            <div>
              {contract_date_key !== null ? (
                contract_date
                  .find(({ option_key }) => option_key === contract_date_key)
                  .mandatory_usage_date?.map((item) => {
                    const isSelect =
                      item.option_key === mandatory_usage_date_key;

                    return (
                      <Card
                        key={`contract_date_${item.option_key}`}
                        size="small"
                        hoverable
                        className="boxShadow"
                        style={{
                          ...styles.card,
                          ...(isSelect && styles.cardSelect),
                        }}
                        actions={[
                          <Button
                            size="small"
                            type="text"
                            onClick={(e) => {
                              e.preventDefault();
                              setData(item);
                              setModal('mandatory_usage_date');
                            }}
                          >
                            <FormOutlined />
                          </Button>,
                          <Button
                            size="small"
                            type="text"
                            style={{ width: '49%' }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleDeleteOption(
                                'mandatory_usage_date',
                                item.option_key
                              );
                            }}
                          >
                            <DeleteOutlined />
                          </Button>,
                        ]}
                      >
                        <div
                          style={styles.cardInner}
                          onClick={() =>
                            set_mandatory_usage_date_key(
                              isSelect ? null : item.option_key
                            )
                          }
                        >
                          <p>{item.option_name}</p>
                          <p
                            style={{
                              textAlign: 'right',
                              fontSize: '0.95em',
                              opacity: 0.75,
                              letterSpacing: -0.5,
                            }}
                          >
                            {/* {console.log('mandatory ===>', item)} */}
                            <Radio
                              style={{ marginRight: 2.5 }}
                              checked={item.default}
                              // onChange={() =>
                              //   handleDefaultValue(
                              //     item.option_key,
                              //     !item.default,
                              //     management,
                              //     set_management
                              //   )
                              // }
                            />
                            기본값
                          </p>
                        </div>
                      </Card>
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
            {/* === 데이터 리스트: end === */}
          </Col>
          {/* ===== [의무사용기간] mandatory_usage_date : end ===== */}

          {/* ===== [선] 납입금 advance_price : start ===== */}
          <Col x={5} style={styles.columnWrapper}>
            <Title
              size={5}
              style={styles.title}
              subButton={
                <Button
                  size="small"
                  shape="round"
                  color="primary"
                  variant="outlined"
                  onClick={() => setModal('advance_price')}
                >
                  +추가
                </Button>
              }
            >
              선납입금
            </Title>
            <Divider style={styles.divider} />
            {/* === 데이터 리스트: start === */}
            <div>
              {advance_price.length > 0 ? (
                advance_price.map((item) => {
                  const isSelect = item.option_key === advance_price_key;

                  return (
                    <Card
                      key={`advance_price_${item.option_key}`}
                      size="small"
                      hoverable
                      className="boxShadow"
                      style={{
                        ...styles.card,
                        ...(isSelect && styles.cardSelect),
                      }}
                      actions={[
                        <Button
                          size="small"
                          type="text"
                          onClick={(e) => {
                            e.preventDefault();
                            setData(item);
                            setModal('advance_price');
                          }}
                        >
                          <FormOutlined />
                        </Button>,
                        <Button
                          size="small"
                          type="text"
                          style={{ width: '49%' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteOption(
                              'advance_price',
                              item.option_key
                            );
                          }}
                        >
                          <DeleteOutlined />
                        </Button>,
                      ]}
                    >
                      <div
                        style={styles.cardInner}
                        onClick={() =>
                          set_advance_price_key(
                            isSelect ? null : item.option_key
                          )
                        }
                      >
                        <p>{item.option_name}</p>
                        <p
                          style={{
                            textAlign: 'right',
                            fontSize: '0.95em',
                            opacity: 0.75,
                            letterSpacing: -0.5,
                          }}
                        >
                          <Radio
                            style={{ marginRight: 2.5 }}
                            checked={item.default}
                            onChange={() =>
                              handleDefaultValue(
                                item.option_key,
                                !item.default,
                                advance_price,
                                set_advance_price
                              )
                            }
                          />
                          기본값
                        </p>
                      </div>
                    </Card>
                  );
                })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
            {/* === 데이터 리스트: end === */}
          </Col>
          {/* ===== [선] 납입금 advance_price : end ===== */}

          {/* ===== [관리유형] management : start ===== */}
          <Col x={5} style={styles.columnWrapper}>
            <Title
              size={5}
              style={styles.title}
              subButton={
                <Button
                  size="small"
                  shape="round"
                  color="primary"
                  variant="outlined"
                  onClick={() => setModal('management')}
                >
                  +추가
                </Button>
              }
            >
              관리유형
            </Title>
            <Divider style={styles.divider} />
            {/* === 데이터 리스트: start === */}
            <div>
              {management.length > 0 ? (
                management.map((item) => {
                  const isSelect = item.option_key === management_key;

                  return (
                    <Card
                      key={`management_${item.option_key}`}
                      size="small"
                      hoverable
                      className="boxShadow"
                      style={{
                        ...styles.card,
                        ...(isSelect && styles.cardSelect),
                      }}
                      actions={[
                        <Button
                          size="small"
                          type="text"
                          onClick={(e) => {
                            e.preventDefault();
                            setData(item);
                            setModal('management');
                          }}
                        >
                          <FormOutlined />
                        </Button>,
                        <Button
                          size="small"
                          type="text"
                          style={{ width: '49%' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteOption('management', item.option_key);
                          }}
                        >
                          <DeleteOutlined />
                        </Button>,
                      ]}
                    >
                      <div
                        style={styles.cardInner}
                        onClick={() =>
                          set_management_key(isSelect ? null : item.option_key)
                        }
                      >
                        <p>{item.option_name}</p>
                        <p
                          style={{
                            textAlign: 'right',
                            fontSize: '0.95em',
                            opacity: 0.75,
                            letterSpacing: -0.5,
                          }}
                        >
                          <Radio
                            style={{ marginRight: 2.5 }}
                            checked={item.default}
                            onChange={() =>
                              handleDefaultValue(
                                item.option_key,
                                !item.default,
                                management,
                                set_management
                              )
                            }
                          />
                          기본값
                        </p>
                      </div>
                    </Card>
                  );
                })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
            {/* === 데이터 리스트: end === */}
          </Col>
          {/* ===== [관리유형] management : end ===== */}

          {/* ===== [추가비용] additional_cost : start ===== */}
          <Col x={4} style={{ ...styles.columnWrapper, paddingRight: 0 }}>
            <Title
              size={5}
              style={styles.title}
              subButton={
                <Button
                  size="small"
                  shape="round"
                  color="primary"
                  variant="outlined"
                  onClick={() => setModal('additional_cost')}
                >
                  +추가
                </Button>
              }
            >
              추가비용
            </Title>
            <Divider style={styles.divider} />
            {/* === 데이터 리스트: start === */}
            <div>
              {additional_cost.length > 0 ? (
                additional_cost.map((item) => {
                  const isSelect = item.option_key === additional_cost_key;

                  return (
                    <Card
                      key={`additional_cost_${item.option_key}`}
                      size="small"
                      hoverable
                      className="boxShadow"
                      style={{
                        ...styles.card,
                        ...(isSelect && styles.cardSelect),
                      }}
                      actions={[
                        <Button
                          size="small"
                          type="text"
                          onClick={(e) => {
                            e.preventDefault();
                            setData(item);
                            setModal('additional_cost');
                          }}
                        >
                          <FormOutlined />
                        </Button>,
                        <Button
                          size="small"
                          type="text"
                          style={{ width: '49%' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteOption(
                              'additional_cost',
                              item.option_key
                            );
                          }}
                        >
                          <DeleteOutlined />
                        </Button>,
                      ]}
                    >
                      <div
                        style={styles.cardInner}
                        onClick={() =>
                          set_additional_cost_key(
                            isSelect ? null : item.option_key
                          )
                        }
                      >
                        <p>{item.option_name}</p>
                        <p
                          style={{
                            textAlign: 'right',
                            fontSize: '0.95em',
                            opacity: 0.75,
                            letterSpacing: -0.5,
                          }}
                        >
                          <Radio
                            style={{ marginRight: 2.5 }}
                            checked={item.default}
                            onChange={() =>
                              handleDefaultValue(
                                item.option_key,
                                !item.default,
                                additional_cost,
                                set_additional_cost
                              )
                            }
                          />
                          기본값
                        </p>
                      </div>
                    </Card>
                  );
                })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
            {/* === 데이터 리스트: end === */}
          </Col>
          {/* ===== [추가비용] additional_cost : end ===== */}
        </Row>
      </Content>

      {/* ===== Modal ===== */}
      <ModalLayout
        type="modal"
        centered
        title={`${handleGetTitle(modal)} 추가`}
        open={modal !== null}
        onCancel={() => setModal(null)}
        closable
        width={480}
        footer={
          <Button
            type="primary"
            onClick={() =>
              data.option_key === null
                ? handleAddOption()
                : handleUpdateOption()
            }
          >
            저장
          </Button>
        }
      >
        <Divider style={{ margin: '15px 0' }} />

        <div>
          <Form
            {...{
              labelCol: {
                xs: {
                  span: 24,
                },
                sm: {
                  span: 6,
                },
              },
              wrapperCol: {
                xs: {
                  span: 24,
                },
                sm: {
                  span: 16,
                },
              },
            }}
          >
            {/*  */}
            <Form.Item label="옵션명">
              <Input
                style={{ width: 270 }}
                placeholder="옵션명"
                value={data.option_name}
                onChange={(e) => onChangeData('option_name', e.target.value)}
              />
            </Form.Item>
            {/*  */}
            {console.log('data ============>', data)}
            {!modal?.includes('date') ? null : (
              <Form.Item label="계약기간">
                <Select
                  style={{ width: 105 }}
                  value={data.option_value}
                  onChange={(e) => onChangeData('option_value', e)}
                  placeholder="개월"
                  options={[
                    { label: '24개월', value: 24 },
                    { label: '36개월', value: 36 },
                    { label: '48개월', value: 48 },
                    { label: '60개월', value: 60 },
                    { label: '직접입력', value: null },
                  ]}
                />{' '}
                <InputNumber
                  style={{ width: 160 }}
                  placeholder="직접입력"
                  value={data.option_value2}
                  onChange={(e) => onChangeData('option_value2', e)}
                  disabled={data.option_value !== null}
                />
              </Form.Item>
            )}

            {/*  */}
            <Form.Item label="금액">
              <Select
                style={{ width: 135 }}
                value={data.option_type}
                onChange={(e) => onChangeData('option_type', e)}
                placeholder="개월"
                options={[
                  { label: '총 금액에 추가', value: 'ADD_TOTAL' },
                  { label: '총 금액에서 할인', value: 'MINUS_TOTAL' },
                  { label: '월 금액에 추가', value: 'ADD_MONTH' },
                  { label: '월 금액에서 할인', value: 'MINUS_MONTH' },
                ]}
              />{' '}
              <InputNumber
                style={{ width: 130 }}
                placeholder="금액"
                value={data.option_price}
                onChange={(e) => onChangeData('option_price', e)}
                min={0}
              />
            </Form.Item>
            {/*  */}
            <Form.Item label="기본값">
              <Checkbox
                checked={data.default}
                onChange={() => onChangeData('default', !data.default)}
              >
                <span style={{ opacity: 0.37 }}>
                  선택 시 기본값으로 사용됩니다.
                </span>
              </Checkbox>
            </Form.Item>
          </Form>
        </div>
        <div></div>
      </ModalLayout>
    </>
  ); // JSX: end
};

const styles = {
  columnWrapper: { paddingRight: 30 },
  title: { fontSize: '1.1em' },
  divider: { margin: '7px 0' },
  card: {
    borderColor: '#eaeaea',
    marginBottom: 7,
  },
  cardSelect: {
    borderColor: '#1677ff',
    backgroundColor: 'rgba(130, 182, 255, 0.2)',
  },
  cardInner: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

SalesInformation_rentalInformation.defaultProps = {
  defaultData: {},
};
export default SalesInformation_rentalInformation;
